// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import '@/config/rem' // 配置flex
import 'normalize.css' // 重置样式表
// import '@/styles/element-ui-style.css' // 重置样式表
import ElementUI from 'element-ui'
import './../theme/index.css'
import qs from 'qs'
import config from '@/config/index'
import defaultAvatar from '@/assets/images/defaultAvatar.png'
import '@/styles/index.scss' // 全局样式
import goToCustomerService from '@/util/customerService'
import SvgIcon from '@/components/Icon/SvgIcon.vue' // svg组件
import { orderStatusText } from '@/filters/order.js'
// import PortalVue from 'portal-vue'
// 注册到全局
Vue.component('icon-svg', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)

const req = require.context('./assets/svg', false, /\.svg$/)
requireAll(req)
const activityIcon = require.context('./assets/svg/activity', false, /\.svg$/)
requireAll(activityIcon)
const orderDetailIcon = require.context('./assets/svg/order-detail', false, /\.svg$/)
requireAll(orderDetailIcon)

Vue.use(ElementUI)
// Vue.use(PortalVue)
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$qs = qs
Vue.prototype.defaultAvatar = defaultAvatar

// 阻止启动生产消息
Vue.config.productionTip = false
// 挂载全局 config
Vue.prototype.config = config
// 注册全局过滤器
Vue.filter('orderStatusText', orderStatusText)

Vue.filter('money', function (value) {
  if (!value) return '0.00'
  var val = value.toFixed(2)
  var intPart = Number(val).toFixed(0)
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  var floatPart = '.00'
  val = value.toString()
  var value2Array = value.split('.')
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString()
    if (floatPart.length === 1) {
      return intPartFormat + '.' + floatPart + '0'
    } else {
      return intPartFormat + '.' + floatPart
    }
  } else {
    return intPartFormat + floatPart
  }
})
// main.js
Vue.filter('formatDateChinese', function (value) {
  if (!value) return ''
  if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
    const [year, month, day] = value.split('-')
    return `${year}年${month}月${day}日`
  }
  const date = new Date(value)
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  return `${year}年${month}月${day}日`
})
// 防止连点
Vue.directive('throttle', {
  bind (el, binding) {
    let timer = null
    const delay = binding.value || 2000
    const eventType = binding.arg || 'click'

    const handler = () => {
      if (timer) return

      timer = setTimeout(() => {
        clearTimeout(timer)
        timer = null
      }, delay)

      // 执行原始事件处理
      if (binding.expression && typeof binding.value === 'function') {
        binding.value()
      }
    }

    el.__throttleHandler__ = handler
    el.addEventListener(eventType, handler)
  },

  unbind (el, binding) {
    const eventType = binding.arg || 'click'
    if (el.__throttleHandler__) {
      el.removeEventListener(eventType, el.__throttleHandler__)
      delete el.__throttleHandler__
    }
  }
})

// 全局手机号隐藏过滤器
Vue.filter('hideMobile', function (mobile) {
  if (!mobile) return ''
  return mobile.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
})

Vue.prototype.openLoading = function () {
  const loading = this.$loading({ // 声明一个loading对象
    lock: true, // 是否锁屏
    target: '.sub-main', // 需要遮罩的区域
    body: true,
    background: '#ffffff',
    customClass: 'mask' // 遮罩层新增类名
  })
  setTimeout(function () { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close() // 关闭遮罩层
  }, 5000)
  return loading
}

// 全局跳转到店铺方法（增强版）
Vue.prototype.$goToStore = function (shopId, params = {}) {
  if (!shopId) {
    console.warn('缺少店铺ID参数')
    this.$message && this.$message.warning('无法跳转到店铺')
    return
  }

  // 构建路由参数
  const routeParams = {
    path: '/store',
    query: {
      shopId: shopId,
      ...params // 支持传递额外参数
    }
  }

  // 检查是否已经在目标页面
  if (this.$route.path === '/store' && this.$route.query.shopId === shopId) {
    console.log('已在目标店铺页面')
    return
  }

  this.$router.push(routeParams).catch(err => {
    console.error('路由跳转失败:', err)
    this.$message && this.$message.error('页面跳转失败')
  })
}
// 将方法挂载到Vue原型上
Vue.prototype.$goToCustomerService = goToCustomerService

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js